export default __webpack_public_path__ + "static/media/ig-stick.881db068.svg";